const usStates = {
    'ALABAMA': 'AL',
    'ALASKA': 'AK',
    'AMERICAN SAMOA': 'AS',
    'ARIZONA': 'AZ',
    'ARKANSAS': 'AR',
    'CALIFORNIA': 'CA',
    'COLORADO': 'CO',
    'CONNECTICUT': 'CT',
    'DELAWARE': 'DE',
    'DISTRICT OF COLUMBIA': 'DC',
    'FEDERATED STATES OF MICRONESIA': 'FM',
    'FLORIDA': 'FL',
    'GEORGIA': 'GA',
    'GUAM': 'GU',
    'HAWAII': 'HI',
    'IDAHO': 'ID',
    'ILLINOIS': 'IL',
    'INDIANA': 'IN',
    'IOWA': 'IA',
    'KANSAS': 'KS',
    'KENTUCKY': 'KY',
    'LOUISIANA': 'LA',
    'MAINE': 'ME',
    'MARSHALL ISLANDS': 'MH',
    'MARYLAND': 'MD',
    'MASSACHUSETTS': 'MA',
    'MICHIGAN': 'MI',
    'MINNESOTA': 'MN',
    'MISSISSIPPI': 'MS',
    'MISSOURI': 'MO',
    'MONTANA': 'MT',
    'NEBRASKA': 'NE',
    'NEVADA': 'NV',
    'NEW HAMPSHIRE': 'NH',
    'NEW JERSEY': 'NJ',
    'NEW MEXICO': 'NM',
    'NEW YORK': 'NY',
    'NORTH CAROLINA': 'NC',
    'NORTH DAKOTA': 'ND',
    'NORTHERN MARIANA ISLANDS': 'MP',
    'OHIO': 'OH',
    'OKLAHOMA': 'OK',
    'OREGON': 'OR',
    'PALAU': 'PW',
    'PENNSYLVANIA': 'PA',
    'PUERTO RICO': 'PR',
    'RHODE ISLAND': 'RI',
    'SOUTH CAROLINA': 'SC',
    'SOUTH DAKOTA': 'SD',
    'TENNESSEE': 'TN',
    'TEXAS': 'TX',
    'UTAH': 'UT',
    'VERMONT': 'VT',
    'VIRGIN ISLANDS': 'VI',
    'VIRGINIA': 'VA',
    'WASHINGTON': 'WA',
    'WEST VIRGINIA': 'WV',
    'WISCONSIN': 'WI',
    'WYOMING': 'WY'
};
var google = google;
const markers = {};
const visibleMarkers = [];
window.theme.autocompleteFired = false;
class LocationsWrapper extends HTMLElement {
    searchWrapper;
    search;
    results;
    text;
    trigger;
    constructor() {
        super();
        this.searchWrapper = this.querySelector('.locations_search-wrapper');
        this.search = this.querySelector('#locations_search');
        this.results = this.querySelector('.locations_results');
        this.text = this.querySelector('.locations_results-text');
        this.trigger = this.querySelector('.locations_map-trigger');
        this.results.addEventListener('click', this.handleClick.bind(this));
        this.searchWrapper.addEventListener('click', this.handleButton.bind(this));
        this.searchWrapper.addEventListener('keypress', this.handleKey.bind(this));
        this.trigger.addEventListener('click', this.handleTrigger.bind(this));
    }
    handleTrigger() {
        if (this.classList.contains('mobile-map'))
            this.classList.remove('mobile-map');
        else
            this.classList.add('mobile-map');
    }
    handleKey(e) {
        if (e.key !== 'Enter')
            return;
        this.handleSearch(false);
    }
    handleButton(e) {
        if (e.target.tagName === 'INPUT')
            return;
        this.handleSearch(e.target.classList.contains('icon-cross'));
    }
    async handleSearch(close) {
        hideMarkers();
        const value = this.search.value.toLowerCase();
        if (value === '' || close) {
            this.search.value = '';
            this.results.innerHTML = '';
            this.text.innerHTML = '';
            this.dataset.status = 'empty';
            window.theme.autocompleteFired = false;
            return;
        }
        else if (window.theme.autocompleteFired === false)
            return;
        this.dataset.status = 'search';
        const place = window.theme.autocomplete.getPlaces()[0];
        let state = place.address_components ?
            place.address_components.find((a) => a.types[0] === 'administrative_area_level_1')
            :
                place.types[0] === 'administrative_area_level_1' ? place.name : place.formatted_address.split(', ').slice(-2)[0].replace(/[0-9]/g, '');
        if (state.length < 4) {
            state = state.replace(/\s+/g, '');
            const nState = Object.keys(usStates).find(key => usStates[key] === state);
            state = nState;
        }
        else if (state.long_name)
            state = state.long_name;
        const filtered = window.theme.locations.filter((location) => location.state.includes(state.toUpperCase()));
        const count = filtered.length === 0 ? 'no locations' : filtered.length === 1 ? '1 location' : filtered.length + ' locations';
        this.text.innerHTML = `${count} near “${this.search.value}”`;
        let html = '';
        if (filtered.length > 0) {
            const coords = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
            let ordered = await calculateDistances(filtered, coords);
            ordered.forEach((location, n) => {
                if (location.comingSoon)
                    html += '<div class="locations_search-result relative coming-soon" ';
                else
                    html += '<div class="locations_search-result relative" ';
                if (n === 0)
                    html += `data-position="1" active data-name="${location.name}">`;
                else
                    html += `data-position="${n + 1}" data-name="${location.name}">`;
                html += `<p class="h6 bold pointer link-hover" data-trigger>${location.name}</p>
          <p class="mb-0">Address</p>
          <p class="grey mb-0">${location.address}, ${location.city}, ${usStates[location.state]} ${location.zip}</p>
          <p class="grey">${location.distance} away</p>
          <p><a href="tel:+1${location.phone.replaceAll('.', '-')}" class="underline">${location.phone}</a></p>
          <location-details class="d-block overflow-hidden">
            <dt class="pointer"><p class="bold d-inline">More details</p></dt>
            <dd>
              <p>Store hours<br />
                <span class="grey">${location.hours}</span>
              <p>
              <a href="${location.link}" target="_blank" class="underline">Get directions</a>
            </dd>
          </location-details>
        </div>`;
            });
            showMarkers(ordered);
        }
        this.results.innerHTML = html;
        window.theme.autocompleteFired = false;
    }
    handleClick(e) {
        if (!e.target.hasAttribute('data-trigger'))
            return;
        const el = e.target;
        const parent = e.target.closest('.locations_search-result');
        this.results.querySelector('[active]').removeAttribute('active');
        parent.setAttribute('active', '');
        changeMarkers(el.textContent);
    }
}
customElements.define('locations-wrapper', LocationsWrapper);
class LocationDetails extends HTMLElement {
    button;
    constructor() {
        super();
        this.button = this.querySelector('dt');
        this.button.addEventListener('click', this.handleClick.bind(this));
    }
    handleClick() {
        if (this.button.hasAttribute('active'))
            this.button.removeAttribute('active');
        else
            this.button.setAttribute('active', '');
    }
}
customElements.define('location-details', LocationDetails);
const mapsScript = document.createElement('script');
mapsScript.async = true;
mapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBWfK6yN91FSZ7wy9bk8rytsJVlTnJ0mL4&libraries=places&callback=initMap';
window.initMap = function initMap() {
    const el = document.getElementById("map");
    const input = document.getElementById("locations_search");
    window.theme.map = new window.google.maps.Map(el, {
        center: { lat: 40.007003551893064, lng: -97.02596061629069 },
        zoom: 4,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
            position: window.google.maps.ControlPosition.TOP_RIGHT,
        },
    });
    window.theme.infoWindow = new window.google.maps.InfoWindow();
    window.theme.selectedIcon = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: "#003057",
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#003057",
        scale: 12,
    };
    window.theme.nonSelectedIcon = {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: "#ffffff",
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#003057",
        scale: 12,
    };
    createMarkers();
    const defaultBounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(18.684221860025186, -160.64157144124755), new window.google.maps.LatLng(49.96192147446389, -58.97690632508309));
    window.theme.autocomplete = new window.google.maps.places.SearchBox(input, { bounds: defaultBounds });
    window.theme.autocomplete.addListener('places_changed', () => {
        window.theme.autocompleteFired = true;
        const button = document.querySelector('#locations-search-button');
        button.click();
    });
}
;
function createMarkers() {
    window.theme.locations.forEach(function (store) {
        const latlng = new window.google.maps.LatLng(store.coordinates[0], store.coordinates[1]);
        let marker = new window.google.maps.Marker({
            title: store.name,
            position: latlng
        });
        markers[store.name] = marker;
        marker.addListener('click', () => {
            changeMarkers(store.name, true);
        });
    });
}
;
function showMarkers(locations) {
    locations.forEach((location, n) => {
        const marker = markers[location.name];
        const i = n + 1 + '';
        if (n === 0) {
            marker.setLabel({ color: '#ffffff', text: i });
            marker.setIcon(window.theme.selectedIcon);
            setInfoWindow(marker);
            zoomMarker(marker);
        }
        else {
            marker.setLabel({ color: '#003057', text: i, fontWeight: 'bold' });
            marker.setIcon(window.theme.nonSelectedIcon);
        }
        marker.setMap(window.theme.map);
        visibleMarkers.push(location.name);
    });
}
function changeMarkers(name, change) {
    visibleMarkers.forEach((markerName, n) => {
        const marker = markers[markerName];
        const i = n + 1 + '';
        if (markerName === name) {
            marker.setLabel({ color: '#ffffff', text: i, fontWeight: 'normal' });
            marker.setIcon(window.theme.selectedIcon);
            setInfoWindow(marker);
            zoomMarker(marker);
        }
        else {
            marker.setLabel({ color: '#003057', text: i, fontWeight: 'bold' });
            marker.setIcon(window.theme.nonSelectedIcon);
        }
    });
    if (change) {
        document.querySelector('.locations_search-result[active]').removeAttribute('active');
        document.querySelector('.locations_search-result[data-name="' + name + '"]').setAttribute('active', '');
    }
}
function hideMarkers() {
    if (visibleMarkers.length === 0)
        return;
    window.theme.infoWindow.close();
    visibleMarkers.forEach(markerName => {
        const marker = markers[markerName];
        marker.setMap(null);
    });
    visibleMarkers.splice(0, visibleMarkers.length);
}
function zoomMarker(el) {
    window.theme.map.setZoom(15);
    window.theme.map.setCenter(el.getPosition());
}
function setInfoWindow(el) {
    if (window.innerWidth < 990)
        return;
    window.theme.infoWindow.close();
    const title = el.getTitle();
    let location = window.theme.locations.filter((l) => l.name === title);
    location = location[0];
    const html = `<div class="left" style="padding:12px">
    <p class="h6" style="max-width:180px"><strong>${location.name}</strong></p>
    <p class="grey mb-0">${location.address}<br> 
      ${location.city}, ${usStates[location.state]} ${location.zip}
    </p>
    <p class="grey">${location.distance} away</p>
    <a href="${location.link}" target="_blank" class="btn w-100 d-block center">Get directions</a>
  </div>`;
    window.theme.infoWindow.setContent(html);
    window.theme.infoWindow.open({ anchor: el, map: window.theme.map, shouldFocus: false });
}
async function calculateDistances(stores, origin) {
    const destinations = [];
    stores.forEach(store => {
        destinations.push({ lat: store.coordinates[0], lng: store.coordinates[1] });
    });
    const service = new window.google.maps.DistanceMatrixService();
    const getDistanceMatrix = (service, parameters) => new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
            if (status != window.google.maps.DistanceMatrixStatus.OK) {
                reject(response);
            }
            else {
                const distances = [];
                const results = response.rows[0].elements;
                for (let j = 0; j < results.length; j++) {
                    const element = results[j];
                    let distanceObject = stores[j];
                    distanceObject.distance = element.distance.text + 'les';
                    distances.push(distanceObject);
                }
                resolve(distances);
            }
        });
    });
    const distancesList = await getDistanceMatrix(service, {
        origins: [origin],
        destinations: destinations,
        travelMode: 'DRIVING',
        unitSystem: window.google.maps.UnitSystem.IMPERIAL,
    });
    distancesList.sort((first, second) => {
        return first.distanceVal - second.distanceVal;
    });
    return distancesList;
}
document.body.appendChild(mapsScript);